<template>
  <el-table
    :data="tableList"
    :show-header="false"
    stripe
    :loading="tableLoading"
    class="basics-table"
  >
    <el-table-column prop="templateName" label="模块" width="120">
      <template slot-scope="scope">
        {{ scope.row.templateName || scope.row.templateCode }}
      </template>
    </el-table-column>
    <el-table-column prop="createTime" show-overflow-tooltip></el-table-column>
    <el-table-column width="70">
      <template slot-scope="scope">
        <div :class="['excel-status', fileStatus(scope.row).status]">{{ fileStatus(scope.row).label }}</div>
      </template>
    </el-table-column>
    <!-- 导入 -->
    <el-table-column v-if="type === 'import'" show-overflow-tooltip>
      <template slot-scope="scope">
        <div v-if="fileStatus(scope.row).status !== 'pending'" class="inline-block">
          <span>成功:</span><em>{{ scope.row.successCount }}</em>
          <span class="ml-1">失败:</span><em class="text-red-600">{{ scope.row.failCount }}</em>
          <el-button  type="text" @click="downloadFile(scope.row)">下载</el-button>
          <!-- <svg-icon icon-class="download" class="ml-4 cursor-pointer primary-color" @click="downloadFile(scope.row)"></svg-icon> -->
        </div>
        <div v-else></div>
      </template>
    </el-table-column>
    <el-table-column v-if="type === 'export'" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-button v-if="fileStatus(scope.row).status === 'success'" type="text" @click="downloadFile(scope.row)">下载</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import ExcelApi from "@/api/excel";
export default {
  name: "ExcelRecord",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "import"
    }
  },
  data() {
    return {
      tableLoading: false,
      tableList: [],
      importTableColumns: [
        {
          name: "文件名称",
          field: "name",
          width: "100"
        },
        {
          name: "操作时间",
          field: "createTime",
          minWidth: "100"
        },
        {
          name: "描述",
          field: "content",
          width: "200"
        }
      ]
    };
  },
  computed: {
    showDownload() {
      return item => true;
    },
    fileStatus() {
      return item => {
        if (item.state === "SUCCEED") {
          return {
            status: "success",
            label: "成功"
          };
        }
        if (item.state === "PROCESSING") {
          return {
            status: "pending",
            label: "处理中"
          };
        }

        return {
          status: "failed",
          label: "失败"
        };
      };
    }
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.tableList = newValue;
      }
    }
  },
  methods: {
    downloadFile(item) {
      if (item && item.attachmentId) {
        ExcelApi.downloadAttachment(item.attachmentId).then(result => {
          this.streamingFileConversion(result);
        });
      } else {
        this.$message.error("暂未生成文件！");
      }
    },
    // 流文件的转换
    streamingFileConversion(result) {
      const blob = new Blob([result.data], {
        type: "application/vnd.ms-excel"
      }); // 构造一个blob对象来处理数据
      const fileName = result.filename; // 导出文件名
      // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      // IE10以上支持blob但是依然不支持download
      if ("download" in document.createElement("a")) {
        // 支持a标签download的浏览器
        const link = document.createElement("a"); // 创建a标签
        link.download = fileName; // a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); // 执行下载
        URL.revokeObjectURL(link.href); // 释放url
        document.body.removeChild(link); // 释放标签
      } else {
        // 其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    }
  }
};
</script>

<style lang="scss">
  .primary-color {
    color: #00b259;
  }

  .excel-status {
    font-size: 12px;
    line-height: 20px;
    color: #505363;

    &::before {
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 4px;
      vertical-align: middle;
      border-radius: 50%;
      content: "";
      transform: translateY(-2px);
    }

    &.success {
      &::before {
        background: #00b259;
      }
    }

    &.failed {
      &::before {
        background: #e60000;
      }
    }

    &.pending {
      &::before {
        background: #505363;
      }
    }
  }

  .basics-table {
    .cell {
      white-space: nowrap !important;
      padding: 0 10px !important;
    }
    td {
      height: 40px;
    }
  }
</style>
